export const handleFilterJql = (preBuildFilter) => {
  let jql, jiraAccountId;
  if (preBuildFilter === 'all') {
    jql = ' order by created DESC';
  }
  if (preBuildFilter === 'all-open') {
    jql = 'resolution = Unresolved order by priority DESC,updated DESC';
  }
  if (preBuildFilter === 'done') {
    jql = 'statusCategory = Done order by updated DESC';
  }
  if (preBuildFilter === 'created-recent') {
    jql = 'created >= -1w order by created DESC';
  }
  if (preBuildFilter === 'viewed-recent') {
    jql = 'issuekey in issueHistory() order by lastViewed DESC';
  }
  if (preBuildFilter === 'resolved-recent') {
    jql = 'resolutiondate >= -1w order by updated DESC';
  }
  if (preBuildFilter === 'updated-recent') {
    jql = 'updated >= -1w order by updated DESC';
  }
  //   if (preBuildFilter === 'my-open') {
  //     jql = `assignee = ${jiraAccountId} AND resolution = Unresolved order by updated DESC`;
  //   }
  //   if (preBuildFilter === 'reported-by-me') {
  //     jql = `reporter = ${jiraAccountId} order by created DESC`;
  //   }
  //   if (preBuildFilter === 'watched-by-me') {
  //     jql = `watcher = ${jiraAccountId} order by created DESC`;
  //   }
  //   if (preBuildFilter === 'assgined-to-me') {
  //     jql = `assignee = ${jiraAccountId} order by created DESC`;
  //   }
  return jql;
};
